/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './addRule.defs.js'
export { main as default } from './addRule.defs.js'
